

















































































































































import {
  defineComponent,
  PropType,
  computed,
  toRefs,
  ref
} from "@vue/composition-api";
import { Wallet } from "@/models/wallet";
import { Tx } from "@/models/tx";
import { ERC20AccountInfo, ERC20TokenInfo } from "@/models/erc20";
import { useUsdTokenPrice, usePrices } from "@/hooks/use-prices";
import { useExplorer } from "@/hooks/use-explorer";
import { useCopy } from "@/hooks/use-copy";
import TransactionItem from "./TransactionItem.vue";
import { useERC20 } from "@/hooks/use-erc20";
import { useVuex } from "@/hooks/use-vuex";
import { useRouter } from "@/hooks/use-router";
import { useFilters } from "@/lib/format";

export default defineComponent({
  components: { TransactionItem },
  props: {
    token: {
      required: true,
      type: Object as PropType<ERC20TokenInfo | ERC20AccountInfo>
    },
    wallet: {
      type: Object as PropType<Wallet>,
      required: true
    }
  },
  setup(props, { emit }) {
    const { token, wallet } = toRefs(props);
    const { tokenPrices, asBaseCurrency, baseCurrency } = usePrices();
    const { ERC20TokenTransfers } = useERC20();
    const router = useRouter();
    const { tokenUrl } = useExplorer();
    const dialog = ref(false);
    const copy = useCopy;
    const { store } = useVuex();

    const url = computed(() =>
      wallet?.value?.network
        ? tokenUrl(wallet?.value?.network, token.value.address)
        : ""
    );

    const openTransaction = (tx: Tx) => {
      store.commit.Wallet.setTransaction(tx);
      router.push("/wallet/transaction");
    };

    const balance = computed(() => {
      const tokenPrice = +useUsdTokenPrice(
        token.value.address,
        "balance" in token.value ? token.value.balance : 0,
        token.value.decimals,
        tokenPrices
      );
      return tokenPrice;
    });

    const price = computed(() => {
      const tokenPrice = +useUsdTokenPrice(
        token.value.address,
        1 * 10 ** token.value.decimals,
        token.value.decimals,
        tokenPrices
      );
      return tokenPrice;
    });

    const txs = computed(() => {
      if (!wallet?.value) return [];
      return ERC20TokenTransfers(token.value.address, wallet?.value);
    });

    return {
      formatToken: useFilters().token,
      price,
      balance,
      asBaseCurrency,
      baseCurrency,
      dialog,
      url,
      copy,
      txs,
      openTransaction
    };
  }
});
